import React from 'react';
import Icon from '@mdi/react';
import { mdiEmoticonFrownOutline  } from '@mdi/js';
import theme from '../theme'; 

export const ReactiveFaceIcon = size => (
  <Icon 
    size={size}
    path={mdiEmoticonFrownOutline }
    title="Reactive"
    color={theme.reactive}
  />
);